// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cafd29b4","453":"51b20bab","622":"385a8472","977":"e217c39c"}[chunkId] + ".chunk.js";
};